import { useCallback } from 'react'
import { Currency, fetchQuery } from '@sequencehq/api'
import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { apiQueryClient } from 'features/api/apiQueryClient'
import { MINUTES } from '@sequencehq/utils/dates'

type UseLoadEnabledCurrencies = () => () => Promise<Currency[]>

export const useLoadEnabledCurrencies: UseLoadEnabledCurrencies = () => {
  const load = useCallback(async () => {
    const accountSettings = await fetchQuery(
      apiQueryClient,
      dashboardv20240509Client.getSequenceAccountSettings,
      undefined,
      { staleTime: 10 * MINUTES }
    )

    return accountSettings?.enabledCurrencies ?? []
  }, [])

  return load
}
